import { mainWeb, imgBaseUrl } from '../config/net'

export const fullImgPath = (relativePath) => {
  return `${imgBaseUrl}${relativePath}`
}

export const mainWebImgPath = (relativePath) => {
  return `${mainWeb}${relativePath}`
}



// WEBPACK FOOTER //
// ./src/tools/img-tools.js